import { FormGroup, AbstractControl, FormControl } from '@angular/forms';

// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

export function dob18YeatsOld(control: AbstractControl){
    if(control.value.length > 0 && control.value.length != 10){
        return {'invalid_date': true};
    }
    let date_components = control.value.split('/');
    if(parseInt(date_components[0]) > 31){
        return {'invalid_date': true};
    }
    if(parseInt(date_components[1]) > 12){
        return {'invalid_date': true};
    }

    let now = new Date();
    if(parseInt(date_components[2]) > now.getFullYear()){
        return {'invalid_date': true};
    }

    if(now.getFullYear() - parseInt(date_components[2]) < 18){
        return {'min_18': true};
    }

    return null;
}

export function PostcodeValidate(control: AbstractControl){
    if(control.value == ''){
        return null;
    }
    
    if(
        !/^[a-zA-Z]*$/g.test(control.value.trim().substring(0,1)) || 
        !/^[a-zA-Z]*$/g.test(control.value.trim().substring(control.value.trim().length,control.value.trim().length-1)) ||
        control.value.trim().length < 5 ||
        control.value.trim().length > 8 ||
        !/\d+/.test(control.value.trim())
    ){
        return {'invalid_postcode': true };
    }

    if(control.hasError('invalid_postcode_uk')){
        return {invalid_postcode_uk: true};
    }

    return null;
}

export interface ValidationResult {
    [key: string]: boolean;
}

export class RegisterFormValidator {

    public static strong(control: FormControl): ValidationResult {
      let enable_registration_phone_validation = localStorage.getItem('enable_registration_phone_validation');
      if(enable_registration_phone_validation == '1') {
        // let hasNumber = /\d/.test(control.value);
        let hasUpper = /[A-Z]/.test(control.value);
        // let hasLower = /[a-z]/.test(control.value);
        // let hasSpecialCharacter = /[£€`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(control.value);
        // console.log('Num, Upp, Low', hasNumber, hasUpper, hasLower);
        const valid = hasUpper && control.value.length > 7;
        if (!valid) {
            // return what´s not valid
            return { strong: true };
        }
      } else {
        let hasNumber = /\d/.test(control.value);
        let hasUpper = /[A-Z]/.test(control.value);
        let hasLower = /[a-z]/.test(control.value);
        let hasSpecialCharacter = /[£€`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(control.value);
        // console.log('Num, Upp, Low', hasNumber, hasUpper, hasLower);
        const valid = hasNumber && hasUpper && hasLower && hasSpecialCharacter && control.value.length > 7 && control.value.length < 17;
        if (!valid) {
            // return what´s not valid
            return { strong: true };
        }
      }

        return null;
    }

    public static email(control: FormControl): ValidationResult {
      if(control.value && control.value.indexOf('.') == -1){
        return {email: true};
      }

      return null;
    }
}